$(function () {
    const mobile_breakpoint = 992;
    const document_width = $(document).width();

    // CLOSE MODAL ONCLICK
    $('body').on('click', '.close-modal', function(){
        $('.modal').modal('hide');
        $('.nav-regions-link').removeClass('active');
        $('.nav-desktop-hidden').slideUp();
    });

    // SELECT COUNTRY SHOW INFO
    $('#contact_country').on('change', function (e) {
        switch (this.value) {
            case 'Indonesia':
                $('.country-container').hide();
                $('#shipping_ID').show();
                $('.shipping-countries').stop().slideDown();
                break;
            case 'Thailand':
                $('.country-container').hide();
                $('#shipping_TH').show();
                $('.shipping-countries').stop().slideDown();
                break;
            case 'Philippines':
                $('.country-container').hide();
                $('#shipping_PH').show();
                $('.shipping-countries').stop().slideDown();
                break;
            case 'Vietnam':
                $('.country-container').hide();
                $('#shipping_VN').show();
                $('.shipping-countries').stop().slideDown();
                break;
            default:
                $('.shipping-countries').stop().slideUp();
        }
    });

    // COUNTRY DROPDOWN
    $.each(store_country.INTL, function (k, v) {
        $('#contact_country').append('<option value="'+country_list[v]+'">'+country_list[v]+'</option>');
    });

    // KR checkbox
    if ($('.terms-kr').length > 0) {
        let checkboxTarget = '.terms-kr .field.stack';
        $(checkboxTarget).change(function() {
            if ($(this).hasClass('all')) {
                if ($(checkboxTarget + '.all .input-checkbox')[0].checked) { $(checkboxTarget + '.single .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.single .input-checkbox').prop('checked', false); }
            } else {
                var allChecked = true;
                $(checkboxTarget + '.single .input-checkbox').each(function(i,v) { if (!this.checked) { allChecked = false; } });
                if (allChecked == true) { $(checkboxTarget + '.all .input-checkbox').prop('checked', true); } else { $(checkboxTarget + '.all .input-checkbox').prop('checked', false); }
            }
        });
    }

    const $submit_button = $('#form_submit'),
          $main_form = $('#external_order_form');

    $submit_button.on('click', function(){ $.validateForm('#external_order_form'); });
    $main_form.submit(function (e) {
        e.preventDefault();

        const formData = new FormData(this);

        let state =  $('#contact_province').val(),
            country =  $('#contact_country').val();
        if ('' !== state) { country = state + ', ' + country; }

        // hard code for form_type due to browser translation if we use hidden field
        formData.append('form_type', "International Register Interest");

        formData.append('from_store', $('body').attr('data-store-code'));
        formData.append('contact_country', country);
        formData.append('form_agree_terms', 1);
        $.submitForm('https://beans.secretlab.co/index.php/api/submit_order_form', formData, $main_form);
    });
});
